import { useMemo } from "react";
import { Button, type ButtonProps, Spinner, Text } from "@bookingcom/bui-react";
import { ArrowNavDownIcon } from "@bookingcom/bui-assets-react/streamline";
import { t, useI18n } from "@bookingcom/lingojs-react";
import type { Airline } from "../../types";
import styles from "./AirlinePicker.module.css";

type AirlinePickerTriggerProps = {
  airlines?: Airline[];
  value?: string;
  isLoading?: boolean;
  placeholder?: string;
} & Pick<ButtonProps, "attributes">;

export const AirlinePickerTrigger = ({
  airlines = [],
  value,
  isLoading,
  placeholder,
  attributes,
}: AirlinePickerTriggerProps) => {
  const i18n = useI18n();

  const airlineName = useMemo(() => airlines.find(({ code }) => code === value)?.name, [value, airlines]);

  return (
    <Button
      size="large"
      variant="secondary-neutral"
      icon={isLoading ? <Spinner size="small" /> : ArrowNavDownIcon}
      iconPosition="end"
      ariaLabel="Select airline"
      className={styles.airlinePickerTrigger}
      attributes={attributes}
      disabled={isLoading || !airlines.length}
    >
      {airlineName ? (
        <Text variant="emphasized_2">{airlineName}</Text>
      ) : (
        <Text variant="emphasized_2" color="disabled">
          {placeholder ?? i18n.trans(t("flights_airline_portal_superuser_overview_report_dropdown_placeholder"))}
        </Text>
      )}
    </Button>
  );
};
